<div class="reset-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    <div class="card reset-card">
      <div class="card-header">
        <h2>Restablecer Contrasena</h2>
      </div>

      <div class="card-body">
        @if (success) {
          <div class="success-banner">
            <div class="success-icon">
              <svg viewBox="0 0 64 64" width="56" height="56" fill="none">
                <circle cx="32" cy="32" r="30" stroke="#22C55E" stroke-width="3"/>
                <path d="M20 32l8 8 16-16" stroke="#22C55E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>Contrasena restablecida</h3>
            <p>Tu contrasena se ha actualizado correctamente. Ya puedes iniciar sesion.</p>
            <button type="button" class="btn btn-primary btn-block" (click)="goToLogin()">
              Ir al login
            </button>
          </div>
        } @else if (!tokenValid) {
          <div class="error-banner">
            <p>{{ error }}</p>
            <a routerLink="/login" class="btn btn-primary btn-block">Volver al login</a>
          </div>
        } @else {
          <p class="reset-info">Introduce tu nueva contrasena</p>

          <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="reset-form">
            <div class="form-group">
              <label for="password">Nueva Contrasena</label>
              <input
                type="password"
                id="password"
                formControlName="password"
                class="form-control"
                [class.is-invalid]="f['password'].invalid && f['password'].touched"
                placeholder="Minimo 6 caracteres"
              >
              @if (f['password'].invalid && f['password'].touched) {
                <div class="error-message">
                  @if (f['password'].errors?.['required']) {
                    <span>Contrasena es requerida</span>
                  }
                  @if (f['password'].errors?.['minlength']) {
                    <span>Contrasena debe tener al menos 6 caracteres</span>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <label for="confirmPassword">Confirmar Contrasena</label>
              <input
                type="password"
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form-control"
                [class.is-invalid]="f['confirmPassword'].invalid && f['confirmPassword'].touched"
                placeholder="Repetir contrasena"
              >
              @if (f['confirmPassword'].invalid && f['confirmPassword'].touched) {
                <div class="error-message">
                  @if (f['confirmPassword'].errors?.['required']) {
                    <span>Confirmacion es requerida</span>
                  }
                  @if (f['confirmPassword'].errors?.['passwordMismatch']) {
                    <span>Las contrasenas no coinciden</span>
                  }
                </div>
              }
            </div>

            <div class="password-requirements">
              <p>La contrasena debe incluir:</p>
              <ul>
                <li>Al menos 6 caracteres</li>
                <li>Una mayuscula y una minuscula</li>
                <li>Un numero</li>
                <li>Un caracter especial (!&#64;#$%...)</li>
              </ul>
            </div>

            @if (error) {
              <div class="error-message global-error">
                {{ error }}
              </div>
            }

            <button
              type="submit"
              class="btn btn-primary btn-block btn-lg"
              [disabled]="loading || resetForm.invalid"
            >
              @if (loading) {
                <span>Restableciendo...</span>
              } @else {
                <span>Restablecer Contrasena</span>
              }
            </button>
          </form>
        }
      </div>

      <div class="card-footer">
        <div class="login-link">
          <p>Recuerdas tu contrasena? <a routerLink="/login" class="login-link-text">Inicia sesion</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
